import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Namespace } from 'enums-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { IFileTypeProvider } from './file-type-provider.service';

@Injectable({ providedIn: 'root' })
export class BullhornFileTypeProviderService implements IFileTypeProvider {
  constructor(private http: HttpClient) {}

  getFileTypes(token: string, entityType: string): Observable<{ id: string; label: string }[]> {
    const sort = (ftA: any, ftB: any) => {
      const a = ftA.label.toLowerCase();
      const b = ftB.label.toLowerCase();
      return a.localeCompare(b);
    };

    const fileTypeList = entityType === 'ClientCorporation' ? 'clientCorporationFileTypeList' : 'fileTypeList';
    return this.getSettings(Namespace.bullhorn, token, fileTypeList).pipe(
      map((response) => response[fileTypeList].map((ft: string) => ({ id: ft, label: ft }))),
      map((fileTypes: any[]) => fileTypes.sort(sort))
    );
  }

  private getSettings(namespace: string, token: string, settings: string): Observable<any> {
    const url = `${environment.kpHost}/datasource/${namespace}/settings?settings=${settings}`;
    const authHeader = { headers: { Authorization: 'bearer ' + token } };
    return this.http.get(url, authHeader);
  }
}
